/**
 *  @class
 *  @function FreeShipping
 */

// if (!customElements.get('free-shipping')) {
//   class FreeShipping extends HTMLElement {
//     constructor() {
//       super();
//     }

//     connectedCallback() {
//       let amount_text = this.querySelector('.free-shipping--text span');
//       let total = parseInt(this.dataset.cartTotal, 10);
//       let minimum = parseInt(this.dataset.minimum, 10);
//       let percentage = 1;

//       this.remainingText = this.querySelector('.free-shipping--text-remaining');
//       this.fullText = this.querySelector('.free-shipping--text-full');

//       if (total < minimum) {
//         percentage = total / minimum;

//         if (amount_text) {
//           let remaining = minimum - total;
//           let format = window.theme.settings.money_with_currency_format || "${{amount}}";
//           amount_text.innerHTML = formatMoney(remaining, format);
//         }

//         this.remainingText.style.display = 'block';
//         this.fullText.style.display = 'none';
//       } else {
//         this.remainingText.style.display = 'none';
//         this.fullText.style.display = 'block';
//       }

//       this.style.setProperty('--percentage', percentage);
//     }
//   }

//   customElements.define('free-shipping', FreeShipping);
// }
/**
 *  @class
 *  @function FreeShipping
 */

if (!customElements.get('free-shipping')) {
  class FreeShipping extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const amountText = this.querySelector('.free-shipping--text span');
      const total = parseInt(this.dataset.cartTotal, 10);
      const minimum = parseInt(this.dataset.minimum, 10);

      let percentage = 1;

      this.remainingText = this.querySelector('.free-shipping--text-remaining');
      this.fullText = this.querySelector('.free-shipping--text-full');

      if (total < minimum) {
        percentage = total / minimum;

        if (amountText) {
          const remaining = minimum - total;
          const countryCode =
            document.documentElement.dataset.countryCode ||
            window.Shopify?.country ||
            'NL';

          amountText.innerHTML = this.formatPriceByCountry(remaining, countryCode, {
            showCurrencyCode: false,
            forceTrailingZeros: true,
          });
        }

        this.remainingText.style.display = 'block';
        this.fullText.style.display = 'none';
      } else {
        this.remainingText.style.display = 'none';
        this.fullText.style.display = 'block';
      }

      this.style.setProperty('--percentage', percentage);
    }

    formatPriceByCountry(price, countryCode, options = {}) {
      const { showCurrencyCode = false, forceTrailingZeros = false } = options;

      price = Math.round(Number(price) || 0);

      const whole = Math.floor(price / 100);
      const cents = price % 100;
      const centsDisplay = String(cents).padStart(2, '0');

      switch (countryCode) {
        case 'DE':
        case 'FR':
        case 'ES':
        case 'FI':
        case 'IT':
        case 'PT':
          return `${whole}${this.getDecimalPart(cents, centsDisplay, ',', ',-', ',00', forceTrailingZeros)} €${showCurrencyCode ? ' EUR' : ''}`;

        case 'NL':
        case 'BE':
          return `€${whole}${this.getDecimalPart(cents, centsDisplay, ',', ',-', ',00', forceTrailingZeros)}${showCurrencyCode ? ' EUR' : ''}`;

        case 'PL':
          return `${whole}${this.getDecimalPart(cents, centsDisplay, ',', ',-', ',00', forceTrailingZeros)} zł${showCurrencyCode ? ' PLN' : ''}`;

        case 'CZ':
          return `${whole}${this.getDecimalPart(cents, centsDisplay, ',', ',-', ',00', forceTrailingZeros)} Kč${showCurrencyCode ? ' CZK' : ''}`;

        case 'NO':
          return `${whole}${this.getDecimalPart(cents, centsDisplay, ',', ',-', ',00', forceTrailingZeros)} kr${showCurrencyCode ? ' NOK' : ''}`;

        case 'DK':
          return `${whole}${this.getDecimalPart(cents, centsDisplay, ',', ',-', ',00', forceTrailingZeros)} kr${showCurrencyCode ? ' DKK' : ''}`;

        case 'SE':
          return `${whole}${this.getDecimalPart(cents, centsDisplay, ',', ',-', ',00', forceTrailingZeros)} kr${showCurrencyCode ? ' SEK' : ''}`;

        case 'CH':
          return `CHF ${whole}${this.getDecimalPart(cents, centsDisplay, '.', '.-', '.00', forceTrailingZeros)}${showCurrencyCode ? ' CHF' : ''}`;

        case 'GB':
          return `£${whole}${this.getDecimalPart(cents, centsDisplay, '.', '.-', '.00', forceTrailingZeros)}${showCurrencyCode ? ' GBP' : ''}`;

        default:
          return this.formatFallback(price, countryCode);
      }
    }

    getDecimalPart(cents, centsDisplay, separator, zeroShort, zeroLong, forceTrailingZeros) {
      if (cents === 0) {
        return forceTrailingZeros ? zeroLong : zeroShort;
      }

      return `${separator}${centsDisplay}`;
    }

    formatFallback(price, countryCode) {
      try {
        const currencyMap = {
          NL: 'EUR',
          BE: 'EUR',
          DE: 'EUR',
          FR: 'EUR',
          ES: 'EUR',
          FI: 'EUR',
          IT: 'EUR',
          PT: 'EUR',
          PL: 'PLN',
          CZ: 'CZK',
          NO: 'NOK',
          DK: 'DKK',
          SE: 'SEK',
          CH: 'CHF',
          GB: 'GBP',
        };

        const currency = currencyMap[countryCode] || 'EUR';

        return new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency,
        }).format(price / 100);
      } catch (e) {
        return `${(price / 100).toFixed(2)}`;
      }
    }
  }

  customElements.define('free-shipping', FreeShipping);
}